document.addEventListener('DOMContentLoaded', function () {
    var IwishVideoSwiper = new Swiper(".IwishVideoSwiper", {
        slidesPerView : 1,
        spaceBetween: 0,
        // loop: true,
        breakpoints: {
            768: {
                slidesPerView : 3,
                spaceBetween: 15,
            },
            1080: {
                slidesPerView : 4,
                spaceBetween: 20,
            },
        },
        navigation: {
            nextEl: ".iwish-reviews-video-box .swiper-button-next",
            prevEl: ".iwish-reviews-video-box .swiper-button-prev",
        },
    });


    $('.iwish-buttom-container .iwish-faq-container .iwish-faq-item .faq-title-container').on('click',function(){
        let d = $(this).next('.faq-content-container').css('display');
        if (!d || d == 'none') {
            $(this).addClass('active');
            $(this).next('.faq-content-container').slideDown(200);
        }else{
            $(this).removeClass('active');
            $(this).next('.faq-content-container').slideUp(200);
        }
    });
    $('.iwish-buttom-container .iwish-more-container span').on('click',function(){
        let t = $(this).text();
        if(t == 'More'){
            $('.iwish-buttom-container .iwish-description-container').addClass('show');
            $(this).html('Hide');
        }else{
            $('.iwish-buttom-container .iwish-description-container').removeClass('show');
            $(this).html('More');
        }
    });
});